import React from 'react';
import classNames from 'classnames';
import CheckBoxInput from './CheckBoxInput';

export default function CheckBoxInputWithLabel(props) {
  const {
    label = '',
    className = '',
    inputClassName = '',
    textMuted = '',
    input,
  } = props;

  const checkBoxId = `check-box-${Math.random()}`;
  return (
    <div className={classNames('form-check check-box-with-label', className, { 'checked-checkbox': input && input.value })}>
      <CheckBoxInput
        className={inputClassName}
        {...props}
        id={checkBoxId}
      />
      <label className="form-check-label" htmlFor={checkBoxId}>
        {label}
      </label>
      {textMuted
        ? <span>{textMuted}</span>
        : null}
    </div>
  );
}
